import { DisabledPrompt, Link } from "bcms-react";

/**
 * @function BID1224ProfilePageContent
 * @return {React.Component}
 * @exported true
 * @description A custom component for the BID 1224's profile page content.
 */
export default function BID1224ProfilePageContent(props) {
  return (
    <div className="flex-container flex-vertical">
      <div className="flex-height link-item">
        <Link to="/email">Email Address</Link>
      </div>
      <div className="flex-height link-item">
        <Link to="/phoneNumber">Phone Number</Link>
      </div>
        <div className="flex-height link-item">
          <DisabledPrompt>
            <Link>Address</Link>
          </DisabledPrompt>
        </div>          
      <div className="flex-height link-item">
        <Link to="/password">Password</Link>
      </div>
      <div className="flex-height link-item">
        <Link to="/userId">User ID</Link>
      </div>
      <div className="flex-height link-item">
        <DisabledPrompt>
          <Link>Unauthorized Devices</Link>
        </DisabledPrompt>
      </div>
    </div>
  );
}